var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    trigger: _vm.isTouch ? 'click' : 'hover',
    content: _vm.tooltip,
  }),expression:"{\n    trigger: isTouch ? 'click' : 'hover',\n    content: tooltip,\n  }"}],staticClass:"eb-info-icon",class:{ 'eb-primary-color': _vm.primary }},[_c('fa',{attrs:{"icon":[_vm.iconStyle, 'info-circle']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }